import React, { Component } from "react";
import Images from "../../commons/Images";
import {
  get720pTranscodedVideo,
  getCDNUrl,
  videoThumbnailFunction,
} from "../../commons/CommonFunctions";
import { authService } from "../../auth";
import axios from "axios";
import stripHtml from "string-strip-html";
import uuid from "react-uuid";
import * as _ from "lodash";
import PresentationPostView from "../../post/PresentationPostView";
import Linkify from "react-linkify";
import ReactHtmlParser from "react-html-parser";
import { renderToString } from "react-dom/server";
import { options } from "../../explore/HashTags/Common/HashtagsCommonFunction";

class CircleIntroItem extends Component {
  constructor(props) {
    super(props);
    let userData = authService.getUserDetailsFromLocalStorage();
    let validation = {
      title: {},
      description: {},
    };
    this.state = {
      userData: userData,
      editedTitle: props.data.title,
      editedDescription: props.data.description,
      validation,
      errors: {},
      loading: false,
      message: "",
      editDocumentTitle: props.data.attachments?.length > 0 && props.data.attachments[0].attachmentType === "PPT" || props.data.attachments[0].attachmentType === "PDF" ?  props.data.attachments[0].title : "",
      attachmentDetails: props.data.attachments?.length > 0 && props.data.attachments[0].attachmentType === "PPT" || props.data.attachments[0].attachmentType === "PDF" ? props.data.attachments[0] : "",
    };
  }

  componentDidMount() {
    let photoListMap = [];
    let photoListOriginalMap = [];
    this.props.data &&
      this.props.data.attachments &&
      this.props.data.attachments.map((attachment, index) => {
        photoListOriginalMap.push(getCDNUrl(attachment.attachmentUrl));
        if (window.innerWidth > 600 && attachment.resizedImages && attachment.resizedImages['600x600'] != null) {
          photoListMap.push(getCDNUrl(attachment.resizedImages['600x600']));
        } else if (window.innerWidth > 320 && window.innerWidth <= 600 && attachment.resizedImages && attachment.resizedImages['400x400'] != null) {
          photoListMap.push(getCDNUrl(attachment.resizedImages['400x400']));
        } else {
          photoListMap.push(getCDNUrl(attachment.attachmentUrl));
        }
      });
    this.setState({
      photoListMap: photoListMap,
      photoListOriginalMap: photoListOriginalMap,
    });

    window.$(".playbutt").bind("contextmenu", function (e) {
      return false;
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.attachments?.length > 0 && nextProps.data.attachments[0].attachmentType === "PPT") {
      this.setState({
        attachmentDetails: nextProps.data.attachments[0]
      })
    }
  }

  deletePost = () => {
    this.setState({ processingDeleteRequest: true });
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/backend/circle/delete-intro-post-by-Id/" +
        this.props.data.id,
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.data && response.data.status === "200 OK") {
          window
            .$("#" + this.props.data.id + "confirmpopForDeleteCirclePost")
            .modal("hide");
          this.setState({ processingDeleteRequest: false });
          this.props.getCirclePostList(this.props.circleData);
        } else {
          this.setState({ processingDeleteRequest: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ processingDeleteRequest: false });
      });
  };

  openDeleteModal = () => {
    window
      .$("#" + this.props.data.id + "confirmpopForDeleteCirclePost")
      .modal("show");
  };

  getMaxChars(str, max) {
    if (str != null) {
      if (str === undefined || str === null) return "";

      var n = str.length;
      if (max > n) {
        return str;
      }

      var res = str.substring(0, max);
      res += "...";
      return res;
    }
  }

  //   Edit Modal Section //

  onHandleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  //   Open edit modal
  openEditModal = () => {
    window.$("#CircleEditPostWrap" + this.props.data.id).modal("show");
  };

  //validation of form
  validateForm = () => {
    this.state.validation.title = {};
    this.state.validation.description = {};
    let formIsValid = true;
    let errors = {};
    if (
      _.isUndefined(this.state.editedTitle) ||
      _.isEmpty(this.state.editedTitle) ||
      _.isNull(this.state.editedTitle)
    ) {
      errors["title"] = "Please enter post title";
      this.state.validation.title = {
        error: true,
        style: { borderColor: "#b34c4c" },
        message: "Please enter title",
      };
      formIsValid = false;
    }

    if (
      _.isUndefined(this.state.editedDescription) ||
      _.isEmpty(this.state.editedDescription) ||
      _.isNull(this.state.editedDescription)
    ) {
      errors["description"] = "Please enter post description";
      this.state.validation.description = {
        error: true,
        style: { borderColor: "#b34c4c" },
        message: "Please enter decription",
      };
      formIsValid = false;
    }
    if (this.props.data.attachments?.length > 0 && (this.props.data.attachments[0].attachmentType === "PPT" || this.props.data.attachments[0].attachmentType === "PDF") && !this.state.editDocumentTitle) {
      errors["documentTitle"] = "Please enter document title";
      this.state.validation.documentTitle = {
        error: true,
        style: { borderColor: "#b34c4c" },
        message: "Please enter document title",
      };
      formIsValid = false;
    }
    if (this.state.editDocumentTitle && (this.state.editDocumentTitle).replace(/\s/g, "").length > 60) {
      errors["documentTitle"] = "Document title should not be greater than 60 characters";
      this.state.validation.documentTitle = {
        error: true,
        style: { borderColor: "#b34c4c" },
        message: "Document title should not be greater than 60 characters",
      };
      formIsValid = false;
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  };

  // Circle update function
  handleEditSubmit = () => {
    this.setState({
      loading: true,
    });
    if (this.validateForm()) {
      let params = {
        userId: this.state.userData.userId,
        id: this.props.data.id,
        circleId: this.props.circleData.id,
        description: this.state.editedDescription,
        title: this.state.editedTitle,
        attachmentTitle: this.state.editDocumentTitle.replace(/\s+/g,' ').trim(),
      };
      axios({
        method: "post",
        url:
          process.env.REACT_APP_userServiceURL +
          "/backend/circle/edit/intro/post",
        data: params,
        withCredentials: true,
      })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.status === "202 ACCEPTED"
          ) {
            this.setState(
              {
                message: "community successfully edited",
                loading: false,
              },
              () => {
                this.props.getCirclePostList();
              }
            );
            window.$("#CircleEditPostWrap" + this.props.data.id).modal("hide");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    setTimeout(
      () =>
        this.setState({
          message: "",
          loading: "false",
          validation: {},
          errors: {},
        }),
      3000
    );
  };

  //   close edit clircle modal
  closeEditModal = () => {
    this.setState(
      {
        editedTitle: this.props.data.title,
        editedDescription: this.props.data.description,
      },
      () => {
        window.$("#CircleEditPostWrap" + this.props.data.id).modal("hide");
      }
    );
  };

  componentWillUnmount() {
    window.$("#CircleEditPostWrap" + this.props.data.id).modal("hide");
    window.$("#" + this.props.data.id + "confirmpopForDeleteCirclePost").modal("hide");
    window.$("#postIntroDescpop"+this.props.data.id).modal("hide");
  }

  render() {
    let linkifiedHtml =
        '<p class="pdtlsLink">' + (renderToString(
            <Linkify
                componentDecorator={(
                    decoratedHref,
                    decoratedText,
                    key
                ) => (
                    <a
                        target="blank"
                        href={decoratedHref}
                        key={key}
                    >
                        {decoratedText}
                    </a>
                )}
            >
                {this.props.data.description
                    ? stripHtml(this.props.data.description)
                    : ""}
            </Linkify>
        )) +
        "</p>";
    linkifiedHtml = renderToString(
        ReactHtmlParser(linkifiedHtml, options)
    );
    return (
      <>
        <div className="item">
          <div className="cWhatWeDoblk">
            {this.props.data &&
              this.props.data.attachments &&
              this.props.data.attachments[0].attachmentType === "VIDEO" ? (
              <figure className="hpostimggrid">
                <div className="himggrid vidbox">
                  {/*<span className="tagtitle">Video No1 Title</span>*/}
                  <a
                    data-fancybox={this.props.data.id}
                    href={getCDNUrl(
                      get720pTranscodedVideo(this.props.data.attachments[0])
                    )}
                  >
                    {(this.props.data?.thumbnail) || (this.props.data.attachments[0].thumbnails && this.props.data.attachments[0].thumbnails[0]) ? (
                      <img
                        src={getCDNUrl(videoThumbnailFunction(this.props.data, true))}
                        alt=""
                      />
                    ) : (
                      <img
                        src="https://cdn.dscovr.com/images/video-blank2.webp"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://cdn.dscovr.com/images/video-blank2.png";
                        }}
                        alt=""
                      />
                    )}
                    <span className="playbutt"><i className="iPlay" /></span>
                  </a>
                </div>
              </figure>
            ) : !_.isEmpty(this.state.attachmentDetails) ?
              <PresentationPostView key={uuid()} attachments={this.state.attachmentDetails} documentTitle={this.state.attachmentDetails?.title} /> :
              (
                <>
                  {this.state.photoListMap &&
                    this.state.photoListMap.length > 0 && (
                      <Images
                        images={this.state.photoListMap}
                        countFrom={3}
                        photoListOriginalMap={this.state.photoListOriginalMap}
                      />
                    )}
                </>
              )}

            <div className="cWhatWeDoblkDesc">
              <h4>{this.props.data.title}</h4>
              <p>
                {this.props.data.description.length <= 108
                  ? this.props.data.description
                  : this.getMaxChars(this.props.data.description, 108)}{" "}
                {this.props.data.description.length > 108 && (
                  <a
                    class="link"
                    href={"#postIntroDescpop" + this.props.data.id}
                    data-toggle="modal"
                  >
                    Know more
                  </a>
                )}
              </p>
              {this.props.circleData &&
                (this.props.circleData.memberType === "Super Admin" ||
                  (this.props.circleData.memberType === "Admin" && this.props.masterConfigData && this.props.masterConfigData.circleUserPermissionMetadata && this.props.masterConfigData.circleUserPermissionMetadata.canCircleIntroPostSend)) && (
                  <div className="contxmenu">
                    <button
                      type="button"
                      className="btn"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="iKebab"></i>
                    </button>
                    <div className="dropdown-menu fadeIn animated">
                      {this.props.data && (
                        <a
                          className="dropdown-item"
                          href="javascript:void(0)"
                          onClick={this.openDeleteModal}
                        >
                          <i className="iTrashBin" /> Delete
                        </a>
                      )}
                      {this.props.data && (
                        <a
                          className="dropdown-item"
                          href="javascript:void(0)"
                          onClick={() => this.openEditModal()}
                        >
                          <i className="iEditBox" /> Edit
                        </a>
                      )}
                    </div>
                  </div>
                )}
            </div>
          </div>

          <div
            id={"postIntroDescpop" + this.props.data.id}
            className="modal fade dgpopup"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="contactInfopop postIntroDescpop">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>

                    <h4>{this.props.data.title}</h4>
                    <p dangerouslySetInnerHTML={{__html: linkifiedHtml}} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade dgpopup confirmpop"
            id={this.props.data.id + "confirmpopForDeleteCirclePost"}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <div className="confirm-popup-modal-body">
                  Are you sure you want to delete this post?
                </div>
                <div className="modal-footer confirm-popup-modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={this.state.processingDeleteRequest}
                    onClick={() => this.deletePost()}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id={"CircleEditPostWrap" + this.props.data.id}
          className="modal fade dgpopup openPostbox"
          key={this.props.data.id}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <section className="toppostwrap">
                  <div className="toppostinn">
                    <div className="toppostpopbody" style={{ borderRadius: '8px 8px 0 0' }}>
                      <div className="toppostpoptop">
                        <div className="tpbfieldlogo">
                          <img
                            src="https://cdn.dscovr.com/images/quotes-logo.webp"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "https://cdn.dscovr.com/images/quotes-logo.png";
                            }}
                            alt=""
                          />
                        </div>
                        <div className="tpbfield">
                          <form action="">
                            <textarea
                              type="text"
                              className="form-control title"
                              value={this.state.editedTitle}
                              onChange={this.onHandleChange}
                              placeholder="Write title here..."
                              id="input_box"
                              name={"editedTitle"}
                            />
                            <span
                              className="login-feedback-error mt-1"
                              style={{ display: "block" }}
                            >
                              {this.state.errors.title}
                            </span>
                            <textarea
                              className="form-control"
                              value={this.state.editedDescription}
                              onChange={this.onHandleChange}
                              placeholder="Write description here..."
                              id="input_box"
                              name={"editedDescription"}
                            />
                            <span
                              className="login-feedback-error mt-1"
                              style={{ display: "block" }}
                            >
                              {this.state.errors.description}
                            </span>
                            {this.props.data.attachments?.length > 0 && (this.props.data.attachments[0].attachmentType === "PPT" || this.props.data.attachments[0].attachmentType === "PDF") &&
                              <div className="presentation-title">
                                <label>Add Document title <sup className="required-field">*</sup></label>
                                <input type="text" class="form-control custom-input" placeholder="Add document title here..." name="editDocumentTitle" value={this.state.editDocumentTitle} onChange={this.onHandleChange} />
                                <span className="login-feedback-error mt-1" style={{ display: "block" }}>{this.state.errors.documentTitle}</span>
                              </div>
                            }
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="bottpostpopbody">
                      <div className="bottpostpopright">
                        <a
                          href="javascript:void(0)"
                          className="btn cancel"
                          onClick={this.closeEditModal}
                        >
                          Cancel
                        </a>
                        <input
                          type="submit"
                          className="btn"
                          onClick={this.handleEditSubmit}
                          value={"POST"}
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CircleIntroItem;
